import React, { useState, useEffect } from 'react';
import './App.css';

// Importar imágenes
import logoPage from './assets/arxdoc.png';
import hospitalImage from './assets/img000.png';

// Importar imágenes de stores
import googlePlayImage from './assets/google-play.jpg';
import appleStoreImage from './assets/apple-store.jpg';

// Importar 8 imágenes distintas para los artículos
import serviceImage001 from './assets/img001.jpg';
import serviceImage002 from './assets/img002.jpg';
import serviceImage003 from './assets/img003.jpg';
import serviceImage004 from './assets/img004.jpg';
import serviceImage005 from './assets/img005.jpg';
import serviceImage006 from './assets/img006.jpg';
import serviceImage007 from './assets/img007.jpg';
import serviceImage008 from './assets/img008.jpg';
import serviceImage009 from './assets/img009.jpg';
import serviceImage010 from './assets/img010.jpg';
import serviceImage011 from './assets/img011.jpg';
import serviceImage012 from './assets/img012.jpg';

// Importar el icono
import articleIcon from './assets/arxbot.png';

// Importar 4 imágenes de clientes
import clientLogo1 from './assets/client1.png';
import clientLogo2 from './assets/client2.png';
import clientLogo3 from './assets/client3.png';
import clientLogo4 from './assets/client4.png';
import clientLogo5 from './assets/client5.png';
import clientLogo6 from './assets/client6.png';
import clientLogo7 from './assets/client7.png';
import clientLogo8 from './assets/client8.png';
import clientLogo9 from './assets/client9.png';
import clientLogo10 from './assets/client10.png';
import clientLogo11 from './assets/client11.png';
import clientLogo12 from './assets/client12.png';
import clientLogo13 from './assets/client13.png';
import clientLogo14 from './assets/client14.png';
import clientLogo15 from './assets/client15.png';


// Importar imagen QR
import qrCodeImage from './assets/qr_code.png';

// Tipado para artículos
type Article = {
  id: number;
  title: string;
  shortDescription: string;
  fullDescription: string;
};

// Imágenes para los artículos
const articleImages = [
  serviceImage001,
  serviceImage002,
  serviceImage003,
  serviceImage004,
  serviceImage005,
  serviceImage006,
  serviceImage007,
  serviceImage008,
  serviceImage009,
  serviceImage010,
  serviceImage011,
  serviceImage012
];

// Contenido de los artículos
const articles: Article[] = [
  {
    id: 1,
    title: 'Interoperabilidad HL7 FHIR',
    shortDescription: 'Estándar para el intercambio de información clínica en sistemas de salud.',
    fullDescription: 'HL7 FHIR (Fast Healthcare Interoperability Resources) es el estándar más moderno para el intercambio de información clínica entre sistemas de salud. Combina lo mejor de HL7 v2, HL7 v3 y CDA usando tecnologías web modernas como RESTful APIs y JSON. FHIR permite la integración ágil entre diferentes sistemas hospitalarios, facilitando el acceso a datos clínicos en tiempo real y mejorando la continuidad de la atención al paciente.'
  },
  {
    id: 2,
    title: 'Interoperabilidad SNOMED CT',
    shortDescription: 'Terminología clínica estandarizada para codificación precisa de diagnósticos.',
    fullDescription: 'SNOMED CT (Systematized Nomenclature of Medicine - Clinical Terms) es el vocabulario clínico más completo y multilingüe para la codificación de información médica. Permite representar de manera consistente los datos clínicos en los registros electrónicos, facilitando el análisis de datos, la investigación clínica y la interoperabilidad entre sistemas. Su estructura jerárquica y relaciones semánticas lo hacen ideal para sistemas de soporte de decisiones clínicas.'
  },
  {
    id: 3,
    title: 'EMPI (Enterprise Master Patient Index)',
    shortDescription: 'Sistema centralizado para identificación única de pacientes.',
    fullDescription: 'El EMPI es un componente crítico en los sistemas de salud modernos que permite la identificación única de pacientes a través de múltiples sistemas y organizaciones. Utiliza algoritmos de matching para vincular registros de un mismo paciente, eliminando duplicados y asegurando que los profesionales de la salud accedan a información completa y precisa. Reduce errores médicos y mejora la seguridad del paciente.'
  },
  {
    id: 4,
    title: 'Receta Electrónica',
    shortDescription: 'Digitalización del proceso de prescripción médica.',
    fullDescription: 'La receta electrónica ha revolucionado el proceso de prescripción médica, eliminando el papel y reduciendo errores. Permite la transmisión directa de prescripciones a farmacias, verificación de interacciones medicamentosas, historial completo de medicación y renovación automatizada. Además, mejora la adherencia al tratamiento y facilita la farmacovigilancia.'
  },
  {
    id: 5,
    title: 'Consentimiento Informado Electrónico',
    shortDescription: 'Digitalización del proceso de consentimiento del paciente.',
    fullDescription: 'El consentimiento informado electrónico moderniza el proceso de obtención de autorizaciones, utilizando firma digital, videos explicativos y verificación de comprensión. Permite almacenamiento seguro, acceso inmediato y auditoría completa. Es especialmente útil para procedimientos quirúrgicos, ensayos clínicos y tratamiento de datos sensibles, cumpliendo con regulaciones como GDPR e HIPAA.'
  },
  {
    id: 6,
    title: 'Portal de Paciente',
    shortDescription: 'Plataforma digital para el empoderamiento del paciente.',
    fullDescription: 'Los portales de paciente son plataformas seguras que permiten a los usuarios acceder a su historial médico, resultados de pruebas, programar citas, comunicarse con profesionales y gestionar tratamientos. Mejoran la experiencia del paciente, promueven la participación activa en su cuidado y reducen la carga administrativa de las instituciones de salud.'
  },
  {
    id: 7,
    title: 'RIS (Radiology Information System)',
    shortDescription: 'Sistema de gestión para departamentos de radiología.',
    fullDescription: 'El RIS es el sistema nervioso central de los departamentos de radiología, gestionando programación de estudios, seguimiento de pacientes, informes radiológicos, facturación e integración con modalidades de imagen y PACS. Los RIS modernos incorporan inteligencia artificial para priorización de casos, control de calidad automatizado y soporte para diagnósticos.'
  },
  {
    id: 8,
    title: 'PACS (Picture Archiving and Communication System)',
    shortDescription: 'Almacenamiento y distribución de imágenes médicas.',
    fullDescription: 'Los sistemas PACS han revolucionado la imagenología médica, reemplazando películas físicas por almacenamiento digital. Permiten visualización remota, procesamiento avanzado de imágenes, integración con RIS y EHR, y soporte para tele-radiología. Las soluciones modernas utilizan almacenamiento en la nube, visualizadores web y algoritmos de IA para análisis asistido.'
  },
  {
    id: 9,
    title: 'LIS (Laboratory Information System)',
    shortDescription: 'Sistema de gestión para laboratorios clínicos.',
    fullDescription: 'El LIS automatiza el flujo de trabajo en laboratorios clínicos, desde la recepción de muestras hasta la emisión de resultados. Gestiona equipos analíticos, control de calidad, validación de resultados e integración con sistemas hospitalarios. Los LIS modernos incorporan trazabilidad completa, alertas inteligentes y soporte para medicina personalizada.'
  },
  {
    id: 10,
    title: 'Telemedicina',
    shortDescription: 'Atención médica a distancia mediante tecnologías digitales.',
    fullDescription: 'La telemedicina ha eliminado barreras geográficas en la atención médica, permitiendo consultas remotas, monitorización de pacientes crónicos, segunda opinión especializada y seguimiento post-operatorio. Combina videoconferencia, dispositivos IoT para medición de signos vitales y plataformas seguras que cumplen con regulaciones de privacidad. Su adopción aceleró notablemente durante la pandemia COVID-19.'
  },
  {
    id: 11,
    title: 'Firma Electrónica Certificada',
    shortDescription: 'Autenticación digital para documentos médicos.',
    fullDescription: 'La firma electrónica certificada proporciona autenticidad, integridad y no repudio en documentos médicos, con validez legal equivalente a la firma manuscrita. Utiliza criptografía asimétrica y certificados digitales emitidos por autoridades reconocidas. Es esencial para historias clínicas electrónicas, informes médicos, consentimientos y prescripciones, cumpliendo con regulaciones como eIDAS en Europa.'
  },
  {
    id: 12,
    title: 'X-Road',
    shortDescription: 'Infraestructura de interoperabilidad segura para datos de salud.',
    fullDescription: 'X-Road es una solución de interoperabilidad segura desarrollada originalmente en Estonia y ahora implementada en varios países. Permite el intercambio de datos entre sistemas heterogéneos manteniendo seguridad, privacidad y trazabilidad. En salud, facilita el acceso a historiales médicos entre instituciones, registros nacionales de vacunación, reporte de enfermedades y análisis de datos poblacionales, todo con estrictos controles de acceso.'
  }
];

// Clientes
const clients = [
  { id: 1, name: 'Relational Database', logo: clientLogo1 },
  { id: 2, name: 'API Management', logo: clientLogo2 },
  { id: 3, name: 'Data Integration Platform', logo: clientLogo3 },
  { id: 4, name: 'HL7 FHIR Server', logo: clientLogo4 },
  { id: 5, name: 'Identity Provider', logo: clientLogo5 }, 
  { id: 6, name: 'Data Integration Platform', logo: clientLogo6 },
  { id: 7, name: 'PACS', logo: clientLogo7 },
  { id: 8, name: 'Containerization', logo: clientLogo8 },
  { id: 9, name: 'Backend Development', logo: clientLogo9 },
  { id: 10, name: 'Frontend Development', logo: clientLogo10 }, 
  { id: 11, name: 'AWS HealthLake', logo: clientLogo11 },
  { id: 12, name: 'Google Cloud Healthcare API', logo: clientLogo12 },
  { id: 13, name: 'Azure FHIR Server', logo: clientLogo13 },
  { id: 14, name: 'Oracle Healthcare Data Repository', logo: clientLogo14 },
  { id: 15, name: 'Red Hat Cloud Services', logo: clientLogo15 }
];

const App: React.FC = () => {
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(articles[3]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Si la pantalla es mayor a 768px, asegurarse de que el menú esté cerrado
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    if (isMobile) {
      setMenuOpen(false); // Cerrar el menú después de hacer clic solo en móvil
    }
  };

  const handleReadMore = (article: Article) => {
    setSelectedArticle(article);
    scrollToSection('section3');
  };

  const handleBackToArticles = () => {
    setSelectedArticle(null);
    scrollToSection('section2');
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="app">
      {/* Encabezado */}
      <header className="header">
        <div className="header-container">
          <div className="logo-container">
            <img src={logoPage} alt="Logo Hospital" className="logo" />
          </div>
          {isMobile && (
            <button 
              className={`mobile-menu-button ${menuOpen ? 'open' : ''}`} 
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {menuOpen ? '✕' : '☰'}
            </button>
          )}
          <nav className={`menu ${menuOpen ? 'open' : ''}`}>
            <ul>
              <li><button onClick={() => scrollToSection('section1')}>Inicio</button></li>
              <li><button onClick={() => scrollToSection('section2')}>Servicios</button></li>
              <li><button onClick={() => scrollToSection('section4')}>Tecnologías</button></li>
              <li><button onClick={() => scrollToSection('footer')}>Contacto</button></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Resto del código permanece igual... */}
      {/* Sección 1 - Imagen principal */}
      <section id="section1" className="hero-section">
        <div className="hero-image-container">
          <img src={hospitalImage} alt="Hospital" className="hero-image" />
          <div className="hero-overlay">
            <h1>Documentos Médicos Seguros</h1>
            <p>Health Cloud | Consultoría técnica | Interoperabilidad</p>
          </div>
        </div>
      </section>

      {/* Sección 2 - Artículos */}
      <section id="section2" className="articles-section">
        <div className="stores-container">
          <img src={googlePlayImage} alt="Google Play" className="store-image" />
          <img src={appleStoreImage} alt="Apple Store" className="store-image" />
        </div>
        
        <div className="section-title">
          <h2>Nuestros Servicios</h2>
          <p>Mejora la calidad asistencial con nuestros servicios integrados</p>
        </div>

        <div className="articles-grid">
          {articles.map(article => (
            <div key={article.id} className="article-card">
              <img src={articleImages[article.id - 1]} alt={article.title} className="article-image" />
              <h3>{article.title}</h3>
              <p>{article.shortDescription}</p>
              <button onClick={() => handleReadMore(article)} className="read-more-btn">
                Leer más...
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Sección 3 - Artículo completo */}
      <section id="section3" className="full-article-section">
        {selectedArticle ? (
          <div className="full-article-container">
            <button onClick={handleBackToArticles} className="back-btn">
              &larr; Volver a servicios
            </button>
            <h2>{selectedArticle.title}</h2>
            <img src={articleImages[selectedArticle.id - 1]} alt={selectedArticle.title} className="full-article-image" />
            <div className="full-article-content">
              <p>{selectedArticle.fullDescription}</p>
            </div>
            {/* Aquí agregamos el nuevo icono con texto */}
            <div className="article-icon-container">
              <div className="contact-info">
                <p>Realizar prueba con el asistente virtual</p>
                <a href="https://chatbot.arxdoc.com.ar/" target="_blank" rel="noopener noreferrer">
                  <img src={articleIcon} alt="Contactar por WhatsApp" className="article-icon" />
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="no-article-selected">
            <h2>Selecciona un servicio para más información</h2>
            <button onClick={() => scrollToSection('section2')} className="back-btn">
              Ver todos los servicios
            </button>
          </div>
        )}
      </section>

      {/* Nueva sección QR */}
      <div className="qr-section">
        <div className="qr-container">
          <h3>Prueba la app de ARxDOC con el siguiente QR</h3>
          <img src={qrCodeImage} alt="Código QR para probar la app" className="qr-image" />
        </div>
      </div>

      {/* Sección 4 - Clientes */}
      <section id="section4" className="clients-section">
        <div className="section-title">
          <h2>Stack Tecnológico</h2>
          <p>Combinamos lo mejor de open-source y soluciones empresariales</p>
        </div>
        <div className="clients-grid">
          {clients.map(client => (
            <div key={client.id} className="client-logo-container">
              <img src={client.logo} alt={client.name} className="client-logo" />
              <p>{client.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pie de página */}
      <footer id="footer" className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logoPage} alt="Logo Hospital" className="logo" />
          </div>
          <div className="social-icons">
            <a href="#" className="social-icon"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-twitter"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-instagram"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="social-icon"><i className="fab fa-youtube"></i></a>
          </div>
          <div className="footer-links">
            <a href="#">Política de Privacidad</a>
            <a href="#">Términos de Servicio</a>
            <a href="mailto:info@arxdoc.com.ar">Contacto</a>
          </div>
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} ARxDOC. Todos los derechos reservados.</p>
            <p className="image-credits">Algunas imágenes utilizadas son de <a href="https://www.freepik.com" target="_blank" rel="noopener noreferrer">Freepik</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;